import React from "react";
import { useSelector } from "react-redux";

import { OrderFilterPage } from "./orderFilter/OrderFilterPage";
import { OrderTablePage } from "./orderTable/OrderTablePage";
import {
  selectOrders,
  selectOrdersQueryArg,
  useGetOrdersListQuery,
} from "../../services/order/orderApiSlice";

import classes from "./orderListPage.module.css";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";

export const OrderListPage = () => {
  const queryArg = useSelector(selectOrdersQueryArg);

  const { isSuccess } = useGetOrdersListQuery(queryArg);

  const orders = useSelector(selectOrders);

  return isSuccess ? (
    <div className={classes.box}>
      <OrderFilterPage />
      <OrderTablePage data={orders} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
